import {
    TouchableHighlight,
    TouchableHighlightProps,
    View,
    ViewStyle
} from 'react-native';
import { COLORS } from '../../config/colors';
import { APP_VARIANT } from '../../config/setting';
import { THEME_COLORS } from '../../theme/constants/themeColors';
import { THEME_STYLES } from '../../theme/constants/themeStyles';
import { AvailableAppVariants } from '../../theme/enums';
import { StyleHelpers } from '../constants/style-helpers';
import CountBadge from './CountBadge';

type Props = {
    icon: any;
    touchableHighlightProps?: TouchableHighlightProps;
    style?: ViewStyle;
    iconColor?: string;
    btnContStyles?: ViewStyle;
    onPress?: () => void;
    showIndicator?: boolean;
    indicatorText?: string;
    underlayColor?: string;
};

const IconButtonHighlight = (props: Props) => {
    const {
        icon,
        style = {},
        touchableHighlightProps = {},
        onPress = () => { },
        btnContStyles = {},
        showIndicator = false,
        indicatorText = '',
        underlayColor = COLORS.grey200,
    } = props;

    return (
        <TouchableHighlight
            // activeOpacity={0.7}
            style={[
                {
                    alignSelf: 'flex-start',
                    // backgroundColor: COLORS.blackTint06,
                    borderRadius: THEME_STYLES.buttonStyle.borderRadius,
                    backgroundColor: THEME_COLORS.buttonBgColor3,
                },
                style,
            ]}
            underlayColor={underlayColor}
            onPress={onPress}>
            <>
                <View
                    style={{
                        borderRadius: 11,
                        borderColor: THEME_COLORS.borderColor,
                        flexDirection: 'row',
                        ...StyleHelpers.totalCenter,
                        paddingVertical: 6,
                        paddingHorizontal: 9,
                        height: 35,
                        width: 35,
                        zIndex: 9,
                        ...THEME_STYLES.buttonBorder,
                        ...btnContStyles,
                    }}>
                    <View>{icon}</View>

                    {
                        showIndicator &&
                        <CountBadge
                            count={indicatorText}
                            style={{
                                top: -8,
                                right: -8,
                            }}
                        />
                    }
                </View>

                {/* {
                    (APP_VARIANT === AvailableAppVariants.PulseEnergyLite) &&
                    <View
                        style={{
                            height: '100%',
                            width: '100%',
                            position: 'absolute',
                            backgroundColor: COLORS.blackColor,
                            bottom: -1,
                            left: 0,
                            right: 0,
                            zIndex: 0,
                            borderRadius: 10,
                            alignSelf: 'flex-start',
                        }}
                    />
                } */}
            </>
        </TouchableHighlight>
    );
};

export default IconButtonHighlight;
